import { render } from "./NRegister.vue?vue&type=template&id=73f869c2"
import script from "./NRegister.vue?vue&type=script&lang=js"
export * from "./NRegister.vue?vue&type=script&lang=js"

import "./NRegister.vue?vue&type=style&index=0&id=73f869c2&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__